<template>
  <span
    v-for="badge in badges"
    :key="badge.id"
    class="inline-flex items-center gap-x-0.5 rounded-md bg-gray-50 px-2 py-1 text-xs font-medium text-gray-600 ring-1 ring-inset ring-gray-500/10"
  >
    {{ badge.nome }}
    <button
      type="button"
      class="group relative -mr-1 w-[14px] h-[14px] rounded-sm hover:bg-gray-500/20"
      @click="emitDelete(badge.id)"
    >
      <span class="sr-only">Remove</span>
      <svg viewBox="0 0 14 14" class="w-[14px] h-[14px] stroke-gray-600/50 group-hover:stroke-gray-600/75">
        <path d="M4 4l6 6m0-6l-6 6" />
      </svg>
      <span class="absolute -inset-1" />
    </button>
  </span>
</template>

<script>
export default {
  name: 'BadgesView',
  emits:['delete-badge'],
  props: {
    badges: {
      type: Array,
      required: true
    }
  },
  methods: {
    emitDelete(id) {
      this.$emit('delete-badge', id);
    }
  }
};
</script>